import * as React from 'react';
import { sync, type SyncState } from '@/lib/sync';

export function useSyncState(sessionId: string | undefined): SyncState {
  return React.useSyncExternalStore(
    (cb) => sync.subscribe(cb),
    () => (sessionId ? sync.status(sessionId) : 'synced'),
    () => 'synced',
  );
}

export function useOnline(): boolean {
  return React.useSyncExternalStore(
    (cb) => {
      window.addEventListener('online', cb);
      window.addEventListener('offline', cb);
      const un = sync.subscribe(cb);
      return () => {
        window.removeEventListener('online', cb);
        window.removeEventListener('offline', cb);
        un();
      };
    },
    () => navigator.onLine && sync.online,
    () => true,
  );
}
